<template>
  <v-overlay class="mit-edit-app" :dark="false" opacity=".8" z-index="1000" :value="show">
    <v-container class="pa-30">
      <v-row>
        <v-col cols="12" class="d-flex justify-left">
          <v-card v-if="editApp" class="card" min-width="600" max-width="600">
            <v-container style="height: 400px; overflow-y: auto;">
            <v-text-field v-model="editApp.appId" label="App Name" placeholder="App Name" outlined></v-text-field>
            <v-label>App Enabled:</v-label>
            <v-combobox :items="booleanOptions" v-model="editApp.enabled" dense outlined solo></v-combobox>
            <v-label>Access:</v-label>
            <p>HINT: To remove a user from access if they are in a group, add their user id to "USER ACCESS" as "*,user_id" </p>
            <v-card elevation="2" outlined>
              <v-tabs  fixed-tabs color="secondary" background-color="primary" dark>
                <v-tab href="#user_tab">
                  User Access
                </v-tab>
                <v-tab-item id="user_tab" key="user_tab" color="primary">
                  <v-card flat class="pa-5">
                    <v-label>This is a comma separated list.</v-label>
                    <div class="mb-5">
                      <p class="examples" @click="menu.user = !menu.user">Examples <v-icon>mdi-help-circle-outline</v-icon></p>
                      <div v-if="menu.user">
                        <ul>
                          <li>"*" value will use the user's default assigned role, this is likely the most commom setting.</li>
                          <li>"*, csailid1" keeping * continues using default role access, as well as gives (override) user csailid1 access at the target level</li>
                          <li>"csailid1, csailid2" gives these two users access at this level, blocking all others (except any groups)</li>
                          <li>The Disabled Users will take presidence over all other settings. So to remove a user that is in a group access, just add their name in the USER ACCESS disabled list.</li>
                        </ul>
                      </div>
                    </div>

                    <v-text-field v-model="editApp.accessUsers['0']" label="Disabled Users" outlined></v-text-field>
                    <v-text-field v-model="editApp.accessUsers['10']" label="Users" outlined></v-text-field>
                    <v-text-field v-model="editApp.accessUsers['20']" label="Managers" outlined></v-text-field>
                    <v-text-field v-model="editApp.accessUsers['30']" label="Admins" outlined></v-text-field>
                  </v-card>
                </v-tab-item>
                <v-tab href="#group_tab">
                  Groups Access
                </v-tab>
                <v-tab-item id="group_tab" key="group_tab">
                  <v-card flat class="pa-5">
                    <v-label>This is a comma separated list.</v-label>
                    <div class="mb-5">
                      <p class="examples" @click="menu.group = !menu.group">Examples <v-icon>mdi-help-circle-outline</v-icon></p>
                      <div v-if="menu.group">
                        <ul>
                          <li>These should be left empty if no special group access is desired</li>
                          <li>Enter any group ids here to give any OIDC groups default access if desired.</li>
                          <li>The most common may be adding "tig" to the admin group for example.</li>
                        </ul>
                      </div>
                    </div>

                    <v-text-field v-model="editApp.accessGroups['0']" label="Disabled Users" outlined></v-text-field>
                    <v-text-field v-model="editApp.accessGroups['10']" label="Users" outlined></v-text-field>
                    <v-text-field v-model="editApp.accessGroups['20']" label="Managers" outlined></v-text-field>
                    <v-text-field v-model="editApp.accessGroups['30']" label="Admins" outlined></v-text-field>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-card>

            <div><v-label>Api Token:</v-label></div>
            <div class="api-token pb-3">
              <v-row class="pl-5 pr-5">
                <v-col cols="9" class="d-flex justify-left">
                  <v-text-field v-model="apiToken" label="Token"></v-text-field>
                </v-col>
                <v-col cols="3" class="d-flex justify-left">
                  <v-btn color="primary" @click="refreshToken()">Get Token</v-btn>
                </v-col>
              </v-row>
            </div>
            <div><v-label>Feature Toggles:</v-label></div>
            <div class="feature-toggle-item pb-3" v-for="(item, index) in editApp.featureToggle" :key="index">
              <v-row class="pl-5 pr-5">
                <v-col cols="7" class="d-flex justify-left">
                  <v-text-field v-model="item.name" label="Feature Name" placeholder="App Name"></v-text-field>
                </v-col>
                <v-col cols="3" class="d-flex justify-left">
                  <v-combobox :items="booleanOptions" v-model="item.enabled" dense solo></v-combobox>
                </v-col>
                <v-col cols="2" class="d-flex justify-left">
                  <v-btn color="primary" @click="editApp.featureToggle.splice(index,1)"><v-icon>mdi-delete</v-icon></v-btn>
                </v-col>
              </v-row>
            </div>
            <v-btn color="primary" @click="addFeatureToggle()">Add Feature</v-btn>
            </v-container>
            <v-card-actions class="pt-10">
              <v-btn color="success" @click="updateModel()">Save</v-btn>
              <v-btn class="ml-5" @click="$emit('cancel')">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-overlay>
</template>

<script>

import MitAppsService from '../services/MitAppsService.js';
import {MitEventBus} from '../../main.js';

export default {
  name: 'MitEditApp',
  components: {},
  props: {
    show: Boolean,
    editApp: Object
  },
  watch: {
    editApp: function (val) {
      this.apiToken = val.apiToken;
    }
  },
  data: function() {
    return {
      menu:{
        user:false,
        group:false
      },
      apiToken:'',
      booleanOptions:[ true,false ]
    }
  },
  methods: {
    addFeatureToggle(){
      this.editApp.featureToggle.push(MitAppsService.getNewFeatureToggle());
    },
    updateModel(){
      //make sure access users are arrays
      for (const key in this.editApp.accessUsers) {
        if(typeof this.editApp.accessUsers[key] === 'string'){
          this.editApp.accessUsers[key] = this.editApp.accessUsers[key].replace(/ /g,'').split(',');
        }
      }
      //make sure access groups are arrays
      for (const key in this.editApp.accessUsers) {
        if(typeof this.editApp.accessUsers[key] === 'string'){
          this.editApp.accessUsers[key] = this.editApp.accessUsers[key].replace(/ /g,'').split(',');
        }
      }

      //little weird that I am doing this as we should be able to bind right to this.editApp
      this.editApp.apiToken = this.apiToken;
      this.$emit('save');
    },
    validate (){
      //Save the new role into the user object
      let result = MitAppsService.jsonValidate();
    },
    refreshToken(){
      if(this.editApp.appId && this.editApp.appId.length > 0){
        MitAppsService.getApiToken(this.editApp.appId)
          .then((tokenData) => {
            this.editApp.apiToken = tokenData.token;
            this.apiToken = tokenData.token;
          })
          .catch((error) => {
            console.log('An error occurred trying get generate an api token', error);

            MitEventBus.$emit('mit-alert--set-alert', {
              message:'An error occurred trying get generate an api token.',
              timeoutMs:3000
            });
          });
      }
      else{
        MitEventBus.$emit('mit-alert--set-alert', {
          message:'Set the app name before generating an api token.',
          timeoutMs:3000
        });
      }

    }
  }

}
</script>

<style lang="scss" scoped>
  .examples {
    cursor: pointer;
    color: #1976d2;
  }
  .card {
    padding: 30px;
  }
  .feature-toggle-item {
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
    margin-bottom: 10px;
  }
</style>
